import OpenIcon from "@/assets/icons/open.svg"
import RelendLogo from "@/assets/icons/relend-light.svg"
import DogCuteSuccess from "@/assets/images/dog-cute-success.png"
import Button from "@/components/base/Button"
import useTrans from "@/hooks/useTrans"
import { TransactionDetail } from "@/utils/dataTypes"
import { Box, Link, Typography } from "@mui/material"
import Image from "next/image"
import NextLink from "next/link"
import { FC } from "react"
import * as styles from "./styles"

type ModalTxResult = {
  transactionDetail: TransactionDetail
  handleCloseModal: () => void
}

const View: FC<ModalTxResult> = ({ transactionDetail, handleCloseModal }) => {
  const { resultImage, title, content, ctaButtonLink, ctaButtonTitle } = transactionDetail
  const trans = useTrans()
  const isDisplayingGoHomeButton = transactionDetail.isDisplayingGoHomeButton === true

  return (
    <Box sx={styles.wrapper} className='relative'>
      <Image
        className='absolute top-0 right-0 z-0 sm:h-52 sm:w-52'
        src={RelendLogo}
        alt='relend'
        width={225}
        height={255}
      />
      <Image
        src={resultImage || DogCuteSuccess}
        alt='hero-stat-icon'
        className='z-10'
        height={182}
        style={{ marginBottom: 16 }}
      />
      <Typography sx={styles.title} className='z-10 text-center'>
        {title}
      </Typography>
      <Typography sx={styles.content} className='z-10 text-center'>
        {content}
      </Typography>
      <Box sx={styles.buttonWrapper} className='z-10'>
        <Button variant='primary' onClick={handleCloseModal} size='lg' data-testid='close-success-modal'>
          {isDisplayingGoHomeButton ? trans.dashboard.modal.go_home : trans.dashboard.modal.ok}
        </Button>

        {ctaButtonLink && (
          <Link
            component={NextLink}
            href={ctaButtonLink}
            rel='noopener noreferrer'
            target='_blank'
            className='text-primary text-center flex items-center justify-center gap-2'
            data-testid='txLink-view-transaction'
          >
            <span>{ctaButtonTitle || trans.dashboard.modal.view_tx}</span>
            <Image className='mr-1 inline' src={OpenIcon} alt='click-icon' width={16} height={16} />
          </Link>
        )}
      </Box>
    </Box>
  )
}

export default View
